import {useEffect, useState} from 'react'
import {processGet} from '../../../services/api'
import useIntl from 'react-intl/src/components/useIntl'
import Select from 'react-select'
import { load } from 'ol/Image'

export const DeviceFilter = (props: any) => {
  const intl = useIntl()
  const [sources, setSources] = useState([])
  const [source_selected, setSourceSelected] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchSources = async () => {
      setLoading(true)
      let sources: any = await processGet('reports/sources', {tz: new Date().getTimezoneOffset()})
      setSources(sources.data)
      setLoading(false)
    }
    fetchSources()
  }, [])

  useEffect(() => {
    props.onChangedSource?.(source_selected)
  }, [props, source_selected])  
  return (
    <>
      <div className='row mb-3'>
        <div className='col-12'>
          <label  className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.SELECT_SOURCE',
            })}
          </label>
        </div>
        {!loading  && <div className='col-12'>
              <Select
                isMulti={true}
                name='server_group'
                options={sources.map((cat: any) => ({
                  value: cat.source_name,
                  label: cat.source_name,
                }))}
                classNamePrefix='select'
                onChange={(selectedOption) => {
                  setSourceSelected(selectedOption)
                }}
                value={source_selected}
              />
            </div> }
            {loading  && <div className='col-12'>
              <div className='form-control'>
              <div className='spinner-border text-primary' role='status' style={{width: '18px', height: '18px'}}>
                <span className='visually-hidden'>Loading...</span>
              </div>
              </div>
            </div> }
        
      </div>
      
    </>
  )
}
